import { atomFamily, atomWithDefault } from 'jotai/utils';
import { endOfMonth, subMonths } from 'date-fns';
import { getCompanySyncIfResolved } from '../../../services/state/CompanyStateJ';
import { KpiPeriod } from '../../../data-models/company-financials.data-model';
import { endOfFiscalPeriod } from '../utils/financialUtils';
import { allCompanyFinancialsState, findLatestDateAndPeriod } from './CompanyFinancialsState';

/**
 * Selected metrics date per company. Default derives from the latest
 * financials date for that company; consumers can override explicitly.
 */
export const selectedMetricsDateCPState = atomFamily((companyId: number) =>
  atomWithDefault<Date | Promise<Date>>(async (get) => {
    const financials = await get(allCompanyFinancialsState(companyId));
    const company = getCompanySyncIfResolved(companyId);
    const fye = company?.fye ?? 12;
    const { latestDate } = findLatestDateAndPeriod(financials, fye);
    return latestDate ?? new Date();
  })
);

/**
 *
 * @param fye [0-11]
 * @param frequency
 * @returns
 */
export function getDefaultFinancialsEndDate(fye: number, frequency: KpiPeriod) {
  const monthsToSubtract = frequency === KpiPeriod.year ? 12 : frequency === KpiPeriod.quarter ? 3 : 1;
  return endOfFiscalPeriod(endOfMonth(subMonths(new Date(), monthsToSubtract)), frequency, fye);
}
